import { useEffect, useState } from "react";
import { ParentGetTeacherEvaluations } from "services/Parent/ParentServices";
import ParentLoader from "./ParentLoader";
import ParentEmpty from "./ParentEmpty";
import { PolarAngleAxis, PolarGrid, PolarRadiusAxis, Radar, RadarChart, ResponsiveContainer, Tooltip } from "recharts";
import ParentFmt from "./ParentFmt";
import { useAuth } from "context/AuthContext";

const ParentEvaluationsTab = ({ studentId }) => {
    const { userInfo } = useAuth();
    const [data, setData] = useState(null);

    useEffect(() => {

        ParentGetTeacherEvaluations(userInfo?.token, Number(studentId)).then(r => setData(r.evaluations)).catch(() => setData([]));

    }, [studentId]);



    if (!data) return <ParentLoader />;

    if (data.length === 0) return <ParentEmpty msg="لا توجد تقييمات للمعلمين" />;



    const latest = data[0];

    const radarData = latest ? [

        { subject: 'المعيار الأول', score: latest.first_result },

        { subject: 'المعيار الثاني', score: latest.second_result },

        { subject: 'المعيار الثالث', score: latest.third_result },

        { subject: 'المعيار الرابع', score: latest.fourth_result },

        { subject: 'المعيار الخامس', score: latest.fifth_result },

        { subject: 'المعيار السادس', score: latest.sixth_result },

    ] : [];



    return (

        <div className="space-y-6">

            {radarData.length > 0 && (

                <div className="bg-white/80 dark:bg-white/5 backdrop-blur-md border border-gray-200 dark:border-white/10 rounded-2xl p-6 shadow-sm flex flex-col items-center">

                    <h3 className="text-lg font-bold text-watomsBlue dark:text-white mb-2 w-full text-right">🎯 أحدث تقييم ({latest.teacher?.employee ? `${latest.teacher.employee.first_name} ${latest.teacher.employee.last_name}` : '—'})</h3>

                    <ResponsiveContainer width="100%" height={300} className="max-w-md">

                        <RadarChart cx="50%" cy="50%" outerRadius="70%" data={radarData}>

                            <PolarGrid stroke="currentColor" className="text-gray-300 dark:text-gray-600" />

                            <PolarAngleAxis dataKey="subject" tick={{ fill: '#64748b', fontSize: 12 }} />

                            <PolarRadiusAxis angle={30} domain={[0, 'auto']} tick={{ fill: '#94a3b8' }} />

                            <Radar name="التقييم" dataKey="score" stroke="#8b5cf6" fill="#8b5cf6" fillOpacity={0.5} />

                            <Tooltip contentStyle={{ borderRadius: '12px', border: 'none', boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)' }} />

                        </RadarChart>

                    </ResponsiveContainer>

                </div>

            )}



            <div className="bg-white/80 dark:bg-white/5 backdrop-blur-md border border-gray-200 dark:border-white/10 rounded-2xl overflow-hidden shadow-sm">

                <div className="overflow-x-auto">

                    <table className="w-full text-base text-right">

                        <thead className="bg-gray-100/80 dark:bg-white/10 text-gray-900 dark:text-gray-100 font-bold border-b border-gray-300 dark:border-white/20">

                            <tr>

                                <th className="px-6 py-4">المعلم</th>

                                <th className="px-6 py-4">النوع</th>

                                <th className="px-6 py-4 text-center">1</th>

                                <th className="px-6 py-4 text-center">2</th>

                                <th className="px-6 py-4 text-center">3</th>

                                <th className="px-6 py-4 text-center">4</th>

                                <th className="px-6 py-4 text-center">5</th>

                                <th className="px-6 py-4 text-center">6</th>

                                <th className="px-6 py-4">التاريخ</th>

                            </tr>

                        </thead>

                        <tbody className="divide-y divide-gray-200 dark:divide-white/5">

                            {data.map(e => {

                                const emp = e.teacher?.employee;

                                const name = emp ? `${emp.first_name} ${emp.middle_name || ''} ${emp.last_name}`.trim() : '—';

                                return (

                                    <tr key={e.id} className="hover:bg-gray-50/50 dark:hover:bg-white/5 transition-colors">

                                        <td className="px-6 py-4 text-gray-900 dark:text-gray-100 font-bold whitespace-nowrap">{name}</td>

                                        <td className="px-6 py-4">

                                            <span className="bg-purple-100 dark:bg-purple-500/20 text-purple-700 dark:text-purple-300 border border-purple-200 dark:border-purple-500/30 px-3 py-1 rounded-full text-sm font-bold whitespace-nowrap shadow-sm">

                                                {e.type === 'interview' ? 'مقابلة' : 'اختبار'}

                                            </span>

                                        </td>

                                        {[e.first_result, e.second_result, e.third_result, e.fourth_result, e.fifth_result, e.sixth_result].map((v, i) => (

                                            <td key={i} className="px-6 py-4 text-center">

                                                <span className="bg-gray-100 dark:bg-white/10 text-gray-800 dark:text-gray-200 border border-gray-300 dark:border-gray-600 px-2 py-1 rounded-md text-sm font-black shadow-sm">{v}</span>

                                            </td>

                                        ))}

                                        <td className="px-6 py-4 text-gray-700 dark:text-gray-300 whitespace-nowrap font-medium">{ParentFmt(e.createdAt)}</td>

                                    </tr>

                                );

                            })}

                        </tbody>

                    </table>

                </div>

            </div>

        </div>

    );
}

export default ParentEvaluationsTab;